import React from 'react';
import PropTypes from 'prop-types';

const Tab = ({
  action, children, disabled, title, badge,
}) => <div className="tabs__tab">{children}</div>;

Tab.propTypes = {
  /** Action da renderizzare nel tab */
  action: PropTypes.node,
  /** Badge da renderizzare nel tab */
  badge: PropTypes.node,
  /** Contenuto da renderizzare all'interno del componente */
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  /** Indica se il componente è disabilitato */
  disabled: PropTypes.bool,
  /** Titolo da visualizzare nell'intestazione del tab */
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
};

Tab.defaultProps = {
  action: null,
  badge: null,
  children: null,
  disabled: false,
};

export default Tab;
